import Table, { Column } from './Table'
export default Table
export { Table, Column }



// WEBPACK FOOTER //
// ../src/components/Table/index.js